import "core-js/modules/es6.function.name";
import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

// 屏蔽 Vue Router 3.1+ 的 NavigationDuplicated 控制台报错
var originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  var result = originalPush.call(this, location);
  if (result && typeof result.catch === 'function') {
    return result.catch(function (err) {
      if (err && err.name === 'NavigationDuplicated') return err;
      return Promise.reject(err);
    });
  }
  return result;
};

/* Layout */
import Layout from '@/layout';

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export var constantRoutes = [{
  path: '/redirect',
  component: Layout,
  hidden: true,
  children: [{
    path: '/redirect/:path*',
    component: function component() {
      return import('@/views/redirect/index');
    }
  }]
}, {
  path: '/login',
  component: function component() {
    return import('@/views/login/index');
  },
  hidden: true
}, {
  path: '/auth-redirect',
  component: function component() {
    return import('@/views/login/auth-redirect');
  },
  hidden: true
}, {
  path: '/404',
  component: function component() {
    return import('@/views/error-page/404');
  },
  hidden: true
}, {
  path: '/401',
  component: function component() {
    return import('@/views/error-page/401');
  },
  hidden: true
}, {
  path: '/',
  component: Layout,
  redirect: '/dashboard',
  isRoot: true,
  name: 'Dashboard',
  meta: {
    title: 'Dashboard',
    icon: 'dashboard'
  },
  auth: ['db', 'reduction'],
  children: [{
    path: 'dashboard',
    component: function component() {
      return import('@/views/dashboard/index');
    },
    name: 'DashboardIndex',
    auth: 'reduction',
    meta: {
      title: 'dashboard',
      icon: 'dashboard',
      affix: true
    }
  }, {
    path: 'dashboard/logs',
    component: function component() {
      return import('@/views/dashboard/log-detail');
    },
    name: 'OperationLogDetail',
    hidden: true,
    auth: 'reduction',
    meta: {
      title: 'Operation Logs',
      icon: 'dashboard',
      noCache: true
    }
  }]
},
// 用户协议&&隐私政策H5页面,不需要登录鉴权
{
  path: '/h5',
  component: function component() {
    return import('@/views/h5/index');
  },
  hidden: true,
  meta: {
    title: 'agreement',
    requiresAuth: false // 设置为 false，表示不需要登录验证
  }
},
// 巴基斯坦智能柜退换政策H5页面,不需要登录鉴权
{
  path: '/pk-policy',
  component: function component() {
    return import('@/views/pk-policy/index');
  },
  hidden: true,
  meta: {
    title: 'pk-policy',
    requiresAuth: false // 设置为 false，表示不需要登录验证
  }
},
// 手机工模检测解决方案H5页面,不需要登录鉴权
{
  path: '/solution-h5',
  component: function component() {
    return import('@/views/solution-h5/index');
  },
  hidden: true,
  meta: {
    title: 'Solution',
    requiresAuth: false // 设置为 false，表示不需要登录验证
  }
},
// 手机工模检测解决方案H5页面--新页面，调取ai接口,不需要登录鉴权
{
  path: '/solution-h5-new',
  component: function component() {
    return import('@/views/solution-h5-new/index');
  },
  hidden: true,
  meta: {
    title: 'Solution',
    requiresAuth: false // 设置为 false，表示不需要登录验证
  }
},
// 手机工模检测check&help对应的文章H5页面,不需要登录鉴权
{
  path: '/article-h5',
  component: function component() {
    return import('@/views/article-h5/index');
  },
  hidden: true,
  meta: {
    title: 'Article',
    requiresAuth: false // 设置为 false，表示不需要登录验证
  }
}];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export var asyncRoutes = [
// 火山看板
{
  path: '/data-wind',
  component: Layout,
  name: 'DataWind',
  meta: {
    title: 'Data Wind',
    icon: 'Partner'
  },
  auth: ['dl'],
  isRoot: true,
  children: [{
    path: 'data-board',
    component: function component() {
      return import('@/views/data-wind/data-board');
    },
    name: 'data board',
    auth: 'super',
    meta: {
      title: 'data board',
      icon: 'shopping',
      noCache: true
    }
  },
  // 防串货监控火山看板
  {
    path: 'data-locking',
    component: function component() {
      return import('@/views/data-wind/data-locking');
    },
    name: 'data locking',
    auth: 'dl',
    meta: {
      title: 'data locking',
      icon: 'shopping',
      noCache: true
    }
  }, {
    path: 'interface-time',
    component: function component() {
      return import('@/views/data-wind/interface-time');
    },
    name: 'Interface Time',
    hidden: true,
    meta: {
      title: 'Interface Time',
      icon: 'shopping',
      noCache: true
    }
  }, {
    path: 'resource-role-urls',
    component: function component() {
      return import('@/views/data-wind/resource-role-urls');
    },
    name: 'Resource Role Urls',
    hidden: true,
    meta: {
      title: 'Resource Role Urls',
      icon: 'shopping',
      noCache: true
    }
  }]
}, {
  path: '/partner',
  component: Layout,
  name: 'storeInfo',
  meta: {
    title: 'partner',
    icon: 'Partner'
  },
  auth: ['n'],
  isRoot: true,
  children: [{
    path: 'shop-info',
    component: function component() {
      return import('@/views/partner/shop-info');
    },
    name: 'shopInfo',
    auth: 'n',
    meta: {
      title: 'storeInfo',
      icon: 'store',
      noCache: true
    }
  }, {
    path: 'feedback-error',
    component: function component() {
      return import('@/views/partner/feedback-error');
    },
    name: 'Feedback Error Info',
    auth: 'n',
    meta: {
      title: 'Feedback Error Info',
      icon: 'store',
      noCache: true
    }
  },
  // {
  //   path: 'store-product',
  //   component: () => import('@/views/partner/store-product'),
  //   name: 'product',
  //   auth: 'n',
  //   meta: { title: 'Store Product', icon: 'shopping', noCache: true }
  // },
  {
    path: 'account',
    component: function component() {
      return import('@/views/partner/account');
    },
    name: 'account',
    auth: 'n',
    meta: {
      title: 'account',
      icon: 'peoples',
      noCache: true
    }
  }]
}, {
  path: '/order-track',
  component: Layout,
  redirect: '/order-track/index',
  name: 'order',
  meta: {
    title: 'reservation',
    icon: 'order'
  },
  // auth: ['orderRes', 'b', 't', 'v'],
  auth: ['b', 't', 'v', 'roa'],
  isRoot: true,
  children: [{
    path: 'banner',
    component: function component() {
      return import('@/views/order/banner');
    },
    name: 'Banner',
    auth: 'super',
    meta: {
      title: 'Banner',
      icon: 'activity',
      noCache: true
    }
  }, {
    path: 'mini-banner',
    component: function component() {
      return import('@/views/order/mini-banner');
    },
    name: 'Mini APP Banner',
    auth: 'super',
    meta: {
      title: 'Mini APP Banner',
      icon: 'activity',
      noCache: true
    }
  }, {
    path: 'index',
    component: function component() {
      return import('@/views/order/index');
    },
    name: 'Reservation Order',
    auth: 'b',
    meta: {
      title: 'Reservation Order',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'res-suspension',
    component: function component() {
      return import('@/views/order/res-suspension');
    },
    name: 'Reservation suspension settings',
    auth: 'super',
    meta: {
      title: 'Reservation suspension settings',
      icon: 'sku',
      noCache: true
    }
  }, {
    path: 'js-order-feedback',
    component: function component() {
      return import('@/views/order/js-order-feedback');
    },
    name: 'JS Order Feedback',
    auth: 'super',
    meta: {
      title: 'JS Order Feedback',
      icon: 'sku',
      noCache: true
    }
  },
  // {
  //   path: 'screen-change',
  //   component: () => import('@/views/order/screen-change'),
  //   name: 'screenChange',
  //   auth: 'xx',
  //   meta: { title: 'Screen Change', icon: 'sku', noCache: true }
  // },
  {
    path: 'track',
    component: function component() {
      return import('@/views/order/track');
    },
    name: 'Order Track',
    auth: 't',
    meta: {
      title: 'Order Track',
      icon: 'online-tracking',
      noCache: true
    }
  }, {
    //   path: 'detail/:id(\\d+)',
    path: 'detail',
    component: function component() {
      return import('@/views/order/detail');
    },
    hidden: true,
    name: 'orderDetail',
    meta: {
      title: 'orderDetail',
      noCache: true
    }
  }, {
    //   path: 'record/:id(\\d+)',
    path: 'record',
    component: function component() {
      return import('@/views/order/record');
    },
    hidden: true,
    name: 'orderRecord',
    meta: {
      title: 'orderRecord',
      noCache: true
    }
  }, {
    // path: 'edit/:id(\\d+)',
    path: 'edit',
    component: function component() {
      return import('@/views/order/edit');
    },
    hidden: true,
    name: 'editOrder',
    meta: {
      title: 'editOrder',
      noCache: true
    }
  }, {
    path: 'create',
    component: function component() {
      return import('@/views/order/create');
    },
    hidden: true,
    name: 'createOrder',
    meta: {
      title: 'createOrder',
      noCache: true
    }
  }, {
    path: 'order-evaluation',
    component: function component() {
      return import('@/views/order/order-evaluation');
    },
    name: 'OrderEvaluation',
    auth: 'v',
    meta: {
      title: 'orderEvaluation',
      icon: 'edit',
      noCache: true
    }
  }, {
    path: 'order-evaluation-new',
    component: function component() {
      return import('@/views/order/order-evaluation-new');
    },
    name: 'Order Evaluation New',
    auth: 'v',
    meta: {
      title: 'Order Evaluation New',
      icon: 'edit',
      noCache: true
    }
  }, {
    path: 'appliance',
    component: function component() {
      return import('@/views/order/appliance');
    },
    name: 'Reservation Order of Applicances',
    auth: 'roa',
    meta: {
      title: 'Reservation Order of Applicances',
      icon: 'edit',
      noCache: true
    }
  }]
},
// 快递订单
{
  path: '/queue',
  component: Layout,
  redirect: '/queue/queue-order',
  name: 'Queue Order',
  alwaysShow: true,
  meta: {
    title: 'Queue Order',
    icon: 'mall'
  },
  isRoot: true,
  auth: ['super'],
  children: [{
    path: 'queue-order',
    component: function component() {
      return import('@/views/queue/queue-order');
    },
    name: 'QueueOrderList',
    auth: 'super',
    meta: {
      title: 'Queue Order',
      icon: 'order',
      noCache: true
    }
  }, {
    path: 'detail',
    component: function component() {
      return import('@/views/queue/detail');
    },
    hidden: true,
    name: 'QueueDetail',
    meta: {
      title: 'Detail',
      icon: 'order',
      noCache: true
    }
  }]
}, {
  path: '/fault-type',
  component: Layout,
  redirect: '/fault-type/Indonesia',
  name: 'FaultType',
  alwaysShow: true,
  hidden: true,
  meta: {
    title: 'FaultType',
    icon: 'mall'
  },
  auth: window.location.host === 'ind-mis-carl.shalltry.com' ? ['j', 'India'] : ['j', 'Indonesia', 'Thailand', 'Philippines', 'Saudi Arabia'],
  isRoot: true,
  children: [{
    path: 'Indonesia',
    component: function component() {
      return import('@/views/fault-type/Indonesia');
    },
    name: 'FaultTypeIndonesia',
    auth: 'Indonesia',
    hidden: window.location.host === 'ind-mis-carl.shalltry.com',
    meta: {
      title: 'Indonesia',
      icon: 'order',
      noCache: true
    }
  }, {
    path: 'Thailand',
    component: function component() {
      return import('@/views/fault-type/Thailand');
    },
    name: 'FaultTypeThailand',
    auth: 'Thailand',
    hidden: window.location.host === 'ind-mis-carl.shalltry.com',
    meta: {
      title: 'Thailand',
      icon: 'order',
      noCache: true
    }
  }, {
    path: 'India',
    component: function component() {
      return import('@/views/fault-type/India');
    },
    name: 'FaultTypeIndia',
    auth: 'India',
    hidden: window.location.host !== 'ind-mis-carl.shalltry.com',
    meta: {
      title: 'India',
      icon: 'order',
      noCache: true
    }
  }, {
    path: 'Philippines',
    component: function component() {
      return import('@/views/fault-type/Philippines');
    },
    name: 'FaultTypePhilippines',
    auth: 'Philippines',
    hidden: window.location.host === 'ind-mis-carl.shalltry.com',
    meta: {
      title: 'Philippines',
      icon: 'order',
      noCache: true
    }
  }, {
    path: 'Saudi',
    component: function component() {
      return import('@/views/fault-type/Saudi');
    },
    name: 'Saudi Arabia',
    auth: 'Saudi Arabia',
    hidden: window.location.host === 'ind-mis-carl.shalltry.com',
    meta: {
      title: 'Saudi Arabia',
      icon: 'order',
      noCache: true
    }
  }]
}, {
  path: '/delivery-store',
  component: Layout,
  redirect: '/delivery-store/Indonesia',
  name: 'Delivery Store List',
  alwaysShow: true,
  meta: {
    title: 'Delivery Store List',
    icon: 'mall'
  },
  auth: window.location.host === 'ind-mis-carl.shalltry.com' ? ['l-2', 'India1'] : ['l-2', 'Indonesia1', 'Thailand1', 'Philippines1'],
  isRoot: true,
  children: [{
    path: 'Indonesia',
    component: function component() {
      return import('@/views/delivery-store/Indonesia');
    },
    name: 'DeliveryStoreIndonesia',
    auth: 'Indonesia1',
    hidden: window.location.host === 'ind-mis-carl.shalltry.com',
    meta: {
      title: 'Indonesia',
      icon: 'order',
      noCache: true
    }
  }, {
    path: 'add-city',
    component: function component() {
      return import('@/views/delivery-store/AddCity');
    },
    hidden: true,
    name: 'Add City',
    meta: {
      title: 'Add City',
      noCache: true
    }
  }, {
    path: 'Thailand',
    component: function component() {
      return import('@/views/delivery-store/Thailand');
    },
    name: 'DeliveryStoreThailand',
    auth: 'Thailand1',
    hidden: window.location.host === 'ind-mis-carl.shalltry.com',
    meta: {
      title: 'Thailand',
      icon: 'order',
      noCache: true
    }
  }, {
    path: 'Philippines',
    component: function component() {
      return import('@/views/delivery-store/Philippines');
    },
    name: 'DeliveryStorePhilippines',
    auth: 'Philippines1',
    hidden: window.location.host === 'ind-mis-carl.shalltry.com',
    meta: {
      title: 'Philippines',
      icon: 'order',
      noCache: true
    }
  }, {
    path: 'India',
    component: function component() {
      return import('@/views/delivery-store/India');
    },
    name: 'DeliveryStoreIndia',
    auth: 'India1',
    hidden: window.location.host !== 'ind-mis-carl.shalltry.com',
    meta: {
      title: 'India',
      icon: 'order',
      noCache: true
    }
  }, {
    path: 'other',
    component: function component() {
      return import('@/views/delivery-store/other');
    },
    name: 'Other Country',
    // auth: 'Thailand1',
    hidden: window.location.host === 'ind-mis-carl.shalltry.com',
    meta: {
      title: 'Other Country',
      icon: 'order',
      noCache: true
    }
  }]
},
// 上门维修订单
{
  path: '/on-site-store',
  component: Layout,
  redirect: '/on-site-store/on-site-setting',
  name: 'On-Site Store List',
  meta: {
    title: 'On-Site Store List',
    icon: 'mall'
  },
  auth: ['os'],
  alwaysShow: true,
  isRoot: true,
  children: [{
    path: 'on-site-setting',
    component: function component() {
      return import('@/views/on-site-store/on-site-setting');
    },
    name: 'On-Site Store Setting',
    auth: 'os',
    meta: {
      title: 'On-Site Store Setting',
      icon: 'order',
      noCache: true
    }
  }, {
    path: '/on-site-store/add-service-location',
    component: function component() {
      return import('@/views/on-site-store/add-service-location');
    },
    hidden: true,
    name: 'OnSiteAddServiceLocation',
    meta: {
      title: 'AddServiceLocation',
      noCache: true
    }
  }, {
    path: '/on-site-store/add-name-setting',
    component: function component() {
      return import('@/views/on-site-store/add-name-setting');
    },
    hidden: true,
    name: 'AddNameSetting',
    meta: {
      title: 'AddNameSetting',
      noCache: true
    }
  }, {
    path: '/on-site-store/device-series-setting',
    component: function component() {
      return import('@/views/on-site-store/device-series-setting');
    },
    hidden: true,
    name: 'DeviceSeriesSetting',
    meta: {
      title: 'DeviceSeriesSetting',
      noCache: true
    }
  }]
},
// 智能柜配置网点服务及服务区域
{
  path: '/cabinet-store',
  component: Layout,
  redirect: '/cabinet-store/cabinet-setting',
  name: 'Cabinet List',
  meta: {
    title: 'Cabinet List',
    icon: 'mall'
  },
  auth: ['cas'],
  alwaysShow: true,
  hidden: true,
  isRoot: true,
  children: [{
    path: 'cabinet-setting',
    component: function component() {
      return import('@/views/cabinet-store/cabinet-setting');
    },
    name: 'Cabinet Setting',
    auth: 'cas',
    meta: {
      title: 'Cabinet Setting',
      icon: 'order',
      noCache: true
    }
  }, {
    path: '/cabinet-store/add-service-location',
    component: function component() {
      return import('@/views/cabinet-store/add-service-location');
    },
    hidden: true,
    name: 'CabinetAddServiceLocation',
    meta: {
      title: 'AddServiceLocation',
      noCache: true
    }
  }]
},
// 智能柜配置故障后台配置
{
  path: '/cabinet-falut',
  component: Layout,
  redirect: '/cabinet-falut/fault-type',
  name: 'Cabinet Fault Type',
  hidden: true,
  alwaysShow: true,
  meta: {
    title: 'Cabinet Fault Type',
    icon: 'order'
  },
  isRoot: true,
  auth: ['cf'],
  children: [{
    path: '/cabinet-falut/fault-type',
    component: function component() {
      return import('@/views/cabinet-falut/fault-type');
    },
    name: 'Cabinet Fault Type List',
    auth: 'cf',
    meta: {
      title: 'Cabinet Fault Type List',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 巴基斯坦预约故障类型后台配置
{
  path: '/reservation-falut',
  component: Layout,
  redirect: '/reservation-falut/index',
  name: 'Reservation Fault Type',
  alwaysShow: true,
  meta: {
    title: 'Reservation Fault Type',
    icon: 'order'
  },
  isRoot: true,
  auth: ['rf'],
  children: [{
    path: '/reservation-falut/index',
    component: function component() {
      return import('@/views/reservation-falut/index');
    },
    name: 'fault type list',
    auth: 'rf',
    meta: {
      title: 'fault type list',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 快递订单
{
  path: '/express-order',
  component: Layout,
  redirect: '/express-order/Indonesia',
  name: 'Express Order',
  alwaysShow: true,
  meta: {
    title: 'Express Order',
    icon: 'mall'
  },
  auth: ['l-4'],
  isRoot: true,
  children: [{
    path: 'Indonesia',
    component: function component() {
      return import('@/views/express-order/Indonesia');
    },
    name: 'ExpressOrderIndonesia',
    auth: 'l-4',
    meta: {
      title: 'Indonesia',
      icon: 'order',
      noCache: true
    }
  }]
},
// {
//   path: '/product-management',
//   component: Layout,
//   redirect: '/product-management/service-management',
//   name: 'ProductManagement',
//   meta: {
//     title: 'productManagement',
//     icon: 'list'
//   },
//   auth: ['category', 'sku', 'service', 'performance', 'product'],
//   isRoot: true,
//   children: [
//     // 5.7.0暂时隐藏
//     // {
//     //   path: 'product-category',
//     //   component: () => import('@/views/product-management/product-category'),
//     //   name: 'ProductCategory',
//     //   auth: 'category',
//     //   meta: { title: 'productCategory', icon: 'category' }
//     // },
//     {
//       path: 'skuManagement',
//       component: () => import('@/views/product-management/sku-management'),
//       name: 'MaterialManagerment',
//       auth: 'sku',
//       meta: { title: 'Material Managerment', icon: 'sku', noCache: true }
//     },
//     {
//       path: 'service-management',
//       component: () =>
//         import('@/views/product-management/service-management'),
//       name: 'ServiceManagement',
//       auth: 'service',
//       meta: { title: 'serviceManagement', icon: 'service', noCache: true }
//     },
//     {
//       path: 'performance-method',
//       component: () =>
//         import('@/views/product-management/performance-method'),
//       name: 'PerformanceMethod',
//       auth: 'performance',
//       meta: { title: 'performanceMethod', icon: 'performance', noCache: true }
//     },
//     {
//       path: 'prod-manage',
//       component: () => import('@/views/product-management/prod-manage'),
//       name: 'ProductManagement',
//       auth: 'product',
//       meta: { title: 'productManagement', icon: 'store', noCache: true }
//     }
//   ]
// },
{
  path: '/service-mall',
  component: Layout,
  redirect: '/service-mall/order',
  name: 'ServiceMall',
  meta: {
    title: 'serviceMall',
    icon: 'mall'
  },
  // auth: ['g', 'sku', 'service', 'performance'],
  auth: ['g'],
  isRoot: true,
  hidden: true,
  children: [{
    path: 'order',
    component: function component() {
      return import('@/views/service-mall/order');
    },
    name: 'orderManagement',
    auth: 'g',
    meta: {
      title: 'orderManagement',
      icon: 'order',
      noCache: true
    }
  }, {
    path: 'record/:id(\\d+)',
    component: function component() {
      return import('@/views/service-mall/record');
    },
    hidden: true,
    name: 'ServiceMallOrderRecord',
    meta: {
      title: 'orderRecord',
      noCache: true
    }
  }]
}, {
  path: '/activity',
  component: Layout,
  redirect: '/activity/list',
  name: 'activity',
  meta: {
    title: 'activity',
    icon: 'activity'
  },
  hidden: true,
  // auth: ['activity'],
  auth: ['super'],
  isRoot: true,
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/activity/list');
    },
    name: 'activityList',
    auth: 'super',
    meta: {
      title: 'activityList',
      icon: 'activity'
    }
  }, {
    path: 'upload-image',
    component: function component() {
      return import('@/views/activity/image');
    },
    name: 'uploadImage',
    auth: 'super',
    meta: {
      title: 'uploadImage',
      icon: 'up-image'
    }
  }]
},
// 促销管理
{
  path: '/promotion-management',
  component: Layout,
  redirect: '/promotion-management/product-h5',
  name: 'promotion-management',
  alwaysShow: true,
  hidden: true,
  meta: {
    title: 'promotionManagement',
    icon: 'chart'
  },
  // auth: ['reduction'],
  isRoot: true,
  children: [
  // {
  //   path: 'order-reduction',
  //   component: () => import('@/views/promotion-management/order-reduction'),
  //   name: 'OrderReduction',
  //   auth: 'reduction',
  //   meta: { title: 'orderReduction', icon: 'reduction', noCache: true }
  // },
  {
    path: 'product-h5',
    component: function component() {
      return import('@/views/promotion-management/product-h5');
    },
    name: 'ProductH5',
    // auth: 'reduction',
    meta: {
      title: 'Product H5',
      icon: 'sku',
      noCache: true
    }
  }, {
    path: 'exclusive-price',
    component: function component() {
      return import('@/views/promotion-management/exclusive-price');
    },
    name: 'ExclusivePrice',
    // auth: 'reduction',
    meta: {
      title: 'Exclusive Price',
      icon: 'shopping',
      noCache: true
    }
  }]
},
// 商品类目配置
{
  path: '/location-category',
  component: Layout,
  redirect: '/location-category/category-management',
  name: 'location-category',
  alwaysShow: true,
  hidden: true,
  meta: {
    title: 'Location Category',
    icon: 'wechat'
  },
  auth: ['l-3'],
  isRoot: true,
  children: [{
    path: 'category-management',
    component: function component() {
      return import('@/views/location-category/category-management');
    },
    name: 'Category Management',
    auth: 'l-3',
    meta: {
      title: 'Category Management',
      icon: 'sku',
      noCache: true
    }
  }, {
    path: 'category-store',
    component: function component() {
      return import('@/views/location-category/category-store');
    },
    name: 'Category Store',
    auth: 'l-3',
    meta: {
      title: 'Category Store',
      icon: 'shopping',
      noCache: true
    }
  }]
},
// 商户入驻信息记录
{
  path: '/store-application',
  component: Layout,
  redirect: '/store-application/application-record',
  name: 'store-application',
  alwaysShow: true,
  hidden: true,
  meta: {
    title: 'Store Application',
    icon: 'user'
  },
  // auth: ['reduction'],
  isRoot: true,
  children: [{
    path: 'application-record',
    component: function component() {
      return import('@/views/store-application/application-record');
    },
    name: 'Application Record',
    auth: 'reduction',
    meta: {
      title: 'Application Record',
      icon: 'sku',
      noCache: true
    }
  }]
},
//  门头广告
{
  path: '/activity-management',
  component: Layout,
  redirect: '/activity-management/index',
  name: 'activity-management',
  alwaysShow: true,
  meta: {
    title: 'Activity Management',
    icon: 'order'
  },
  isRoot: true,
  auth: ['a-1'],
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/activity-management/index');
    },
    name: 'Doorway Advertisement',
    hidden: true,
    meta: {
      title: 'Doorway Advertisement',
      icon: 'rorder',
      noCache: true
    },
    auth: 'super'
  }, {
    path: 'detail',
    component: function component() {
      return import('@/views/activity-management/detail');
    },
    hidden: true,
    name: 'ActivityManagementDetail',
    auth: 'super',
    meta: {
      title: 'Detail',
      noCache: true
    }
  }, {
    path: 'monthly-detail',
    component: function component() {
      return import('@/views/activity-management/monthly-detail');
    },
    hidden: true,
    name: 'Monthly Detail',
    meta: {
      title: 'Monthly Detail',
      noCache: true
    }
  }, {
    path: 'commission-setting',
    component: function component() {
      return import('@/views/activity-management/commission-setting');
    },
    hidden: true,
    name: 'Commission Setting',
    auth: 'super',
    meta: {
      title: 'Commission Setting',
      noCache: true
    }
  }, {
    path: 'edit-commission',
    component: function component() {
      return import('@/views/activity-management/edit-commission');
    },
    hidden: true,
    name: 'Edit Commission',
    auth: 'super',
    meta: {
      title: 'Edit Commission',
      noCache: true
    }
  }, {
    path: 'create',
    component: function component() {
      return import('@/views/activity-management/add-commission');
    },
    hidden: true,
    name: 'Add Commission',
    auth: 'super',
    meta: {
      title: 'Add Commission',
      noCache: true
    }
  }, {
    path: 'activity-configuration',
    component: function component() {
      return import('@/views/activity-management/activity-configuration');
    },
    name: 'Activity Configuration',
    auth: 'a-1',
    meta: {
      title: 'Activity Configuration',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'puzzle-game',
    component: function component() {
      return import('@/views/activity-management/puzzle-game');
    },
    name: 'Puzzle Game',
    auth: 'a-1',
    hidden: true,
    meta: {
      title: 'Puzzle Game',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'order-rank',
    component: function component() {
      return import('@/views/activity-management/order-rank');
    },
    name: 'Halloween Finished Order',
    hidden: true,
    auth: 'super',
    meta: {
      title: 'Halloween Finished Order',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'rank-detail',
    component: function component() {
      return import('@/views/activity-management/rank-detail');
    },
    hidden: true,
    name: 'RankDetail',
    auth: 'super',
    meta: {
      title: 'RankDetail',
      noCache: true
    }
  }, {
    path: 'change-screen',
    component: function component() {
      return import('@/views/activity-management/change-screen');
    },
    name: 'Change Screen Order',
    hidden: true,
    auth: 'super',
    meta: {
      title: 'Change Screen Order',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'screen-detail',
    component: function component() {
      return import('@/views/activity-management/screen-detail');
    },
    name: 'Change Screen Detail',
    hidden: true,
    auth: 'super',
    meta: {
      title: 'Change Screen Detail',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'anniversary-image-prize',
    component: function component() {
      return import('@/views/activity-management/anniversary-image-prize');
    },
    name: 'Anniversary Image Prize',
    hidden: true,
    auth: 'super',
    meta: {
      title: 'Anniversary Image Prize',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'independence-day',
    component: function component() {
      return import('@/views/activity-management/independence-day');
    },
    name: 'Independence Day',
    auth: 'super',
    hidden: true,
    meta: {
      title: 'Independence Day',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'collect-card',
    component: function component() {
      return import('@/views/activity-management/collect-card');
    },
    name: 'Collect Card',
    auth: 'a-1',
    meta: {
      title: 'Collect Card',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'h5-survey-lottery',
    component: function component() {
      return import('@/views/activity-management/h5-survey-lottery');
    },
    name: 'H5 Survey Lottery',
    auth: 'a-1',
    meta: {
      title: 'H5 Survey Lottery',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 老后台的Activity模块
{
  path: '/activity-bg',
  component: Layout,
  redirect: '/activity-bg/lottery-record',
  name: 'Activity',
  meta: {
    title: 'Activity',
    icon: 'activity'
  },
  auth: ['x'],
  alwaysShow: true,
  isRoot: true,
  children: [{
    path: 'lottery-record',
    component: function component() {
      return import('@/views/activity-bg/lottery-record');
    },
    name: 'LotteryRecord',
    auth: 'x',
    meta: {
      title: 'Lottery Record',
      icon: 'activity'
    }
  }, {
    path: 'airtime-data',
    component: function component() {
      return import('@/views/activity-bg/airtime-data');
    },
    hidden: true,
    name: 'AirtimeMobileData',
    auth: 'super',
    meta: {
      title: 'Airtime&Mobile Data',
      icon: 'activity'
    }
  }, {
    path: 'winning-record',
    component: function component() {
      return import('@/views/activity-bg/winning-record');
    },
    name: 'A&DWinningRecord',
    hidden: true,
    auth: 'super',
    meta: {
      title: 'A&D Winning Record',
      icon: 'activity'
    }
  }, {
    path: 'merchant-record',
    component: function component() {
      return import('@/views/activity-bg/merchant-record');
    },
    name: 'MerchantRecord',
    hidden: true,
    auth: 'x',
    meta: {
      title: 'Merchant Record',
      icon: 'activity'
    }
  }, {
    path: 'user-benefits',
    component: function component() {
      return import('@/views/activity-bg/user-benefits');
    },
    name: 'UserBenefits',
    hidden: true,
    auth: 'super',
    meta: {
      title: 'User Benefits',
      icon: 'activity'
    }
  }, {
    path: 'withdrawal-record',
    component: function component() {
      return import('@/views/activity-bg/withdrawal-record');
    },
    name: 'WithdrawalRecord',
    hidden: true,
    auth: 'super',
    meta: {
      title: 'Withdrawal Record',
      icon: 'activity'
    }
  }, {
    path: 'benefits-detail',
    component: function component() {
      return import('@/views/activity-bg/benefits-detail');
    },
    name: 'ActivityBgDetail',
    auth: 'super',
    hidden: true,
    meta: {
      title: 'Detail',
      icon: 'activity'
    }
  }]
},
// Admin 老后台模块
{
  path: '/admin-bg',
  component: Layout,
  redirect: '/admin-bg/user-info',
  name: 'Admin',
  alwaysShow: true,
  meta: {
    title: 'Admin',
    icon: 'order'
  },
  isRoot: true,
  auth: ['ui'],
  children: [{
    path: '/admin-bg/admin-info',
    component: function component() {
      return import('@/views/admin-bg/admin-info');
    },
    name: 'AdminInfo',
    auth: 'super',
    meta: {
      title: 'Admin Info',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/admin-bg/user-info',
    component: function component() {
      return import('@/views/admin-bg/user-info');
    },
    name: 'UserInfo',
    auth: 'ui',
    meta: {
      title: 'User Info',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/admin-bg/device-info',
    component: function component() {
      return import('@/views/admin-bg/device-info');
    },
    name: 'DeviceInfo',
    auth: 'super',
    meta: {
      title: 'Device Info',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/admin-bg/statistics',
    component: function component() {
      return import('@/views/admin-bg/statistics');
    },
    name: 'StatisticsManage',
    auth: 'super',
    meta: {
      title: 'Statistics Manage',
      icon: 'rorder',
      noCache: true
    }
  },
  // {
  //   path: '/admin-bg/app-version',
  //   component: () => import('@/views/admin-bg/app-version'),
  //   name: 'AppVersion',
  //   meta: { title: 'App Version', icon: 'rorder', noCache: true }
  // },
  {
    path: '/admin-bg/app-version-new',
    component: function component() {
      return import('@/views/admin-bg/app-version-new');
    },
    name: 'AppVersion',
    auth: 'super',
    meta: {
      title: 'App Version',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/admin-bg/h5-whitelist',
    component: function component() {
      return import('@/views/admin-bg/h5-whitelist');
    },
    name: 'H5Whitelist',
    auth: 'super',
    meta: {
      title: 'External H5 whitelist',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/admin-bg/country-list',
    component: function component() {
      return import('@/views/admin-bg/country-list');
    },
    name: 'CountryList',
    auth: 'super',
    meta: {
      title: 'Country Info',
      icon: 'rorder',
      noCache: true
    }
  }]
},
//  论坛模块
{
  path: '/forum',
  component: Layout,
  redirect: '/forum/web-post',
  name: 'Forum',
  alwaysShow: true,
  // hidden: true,
  meta: {
    title: 'Forum',
    icon: 'order'
  },
  isRoot: true,
  auth: ['p', 'op', 'ac', 'lr', 'ba', 'ch', 'cs'],
  children: [{
    path: '/forum/app-post',
    component: function component() {
      return import('@/views/forum/app-post');
    },
    name: 'Posts',
    auth: 'p',
    meta: {
      title: 'Posts',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/forum/app-post-detail',
    component: function component() {
      return import('@/views/forum/app-post-detail');
    },
    name: 'PostDetail',
    auth: 'p',
    hidden: true,
    meta: {
      title: 'PostDetail',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/forum/web-post',
    component: function component() {
      return import('@/views/forum/web-post');
    },
    name: 'Official Post',
    auth: 'op',
    meta: {
      title: 'Official Post',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/forum/update-web-post',
    component: function component() {
      return import('@/views/forum/update-web-post');
    },
    name: 'UpdateWebPost',
    auth: 'op',
    hidden: true,
    meta: {
      title: 'UpdateWebPost',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/forum/web-post-detail',
    component: function component() {
      return import('@/views/forum/web-post-detail');
    },
    name: 'WebPostDetail',
    auth: 'op',
    hidden: true,
    meta: {
      title: 'WebPostDetail',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/forum/activity-center',
    component: function component() {
      return import('@/views/forum/activity-center');
    },
    name: 'Activity Center',
    auth: 'ac',
    meta: {
      title: 'Activity Center',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/forum/language-region',
    component: function component() {
      return import('@/views/forum/language-region');
    },
    name: 'Language & Region',
    auth: 'lr',
    meta: {
      title: 'Language & Region',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/forum/ban-account',
    component: function component() {
      return import('@/views/forum/ban-account');
    },
    name: 'Ban Account',
    auth: 'ba',
    meta: {
      title: 'Ban Account',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/forum/hidden-country-share-btn',
    component: function component() {
      return import('@/views/forum/hidden-country-share-btn');
    },
    name: 'Country of hidden share button',
    auth: 'ch',
    meta: {
      title: 'Country of hidden share button',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/forum/show-country-consult-btn',
    component: function component() {
      return import('@/views/forum/show-country-consult-btn');
    },
    name: 'Country of showing consult button',
    auth: 'cs',
    meta: {
      title: 'Country of showing consult button',
      icon: 'rorder',
      noCache: true
    }
  }
  // {
  //   path: '/home-config/detail',
  //   component: () => import('@/views/home-config/detail'),
  //   name: 'Detail',
  //   hidden: true,
  //   meta: { title: 'Detail', icon: 'rorder', noCache: true }
  // }
  ]
},
//  Home 首页配置模块
{
  path: '/home-config',
  component: Layout,
  redirect: '/home-config/home',
  name: 'Home Configuration',
  alwaysShow: true,
  meta: {
    title: 'Home Configuration',
    icon: 'order'
  },
  isRoot: true,
  auth: ['ban', 'u'],
  children: [{
    path: '/home-config/home',
    component: function component() {
      return import('@/views/home-config/home');
    },
    name: 'Home',
    auth: 'u',
    meta: {
      title: 'Home',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/home-config/app-pop',
    component: function component() {
      return import('@/views/home-config/app-pop');
    },
    name: 'APP HomePage Pop-up',
    auth: 'u',
    meta: {
      title: 'APP HomePage Pop-up',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/home-config/web-pop',
    component: function component() {
      return import('@/views/home-config/web-pop');
    },
    name: 'Web HomePage Pop-up',
    auth: 'u',
    meta: {
      title: 'Web HomePage Pop-up',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/home-config/discovery',
    component: function component() {
      return import('@/views/home-config/discovery');
    },
    name: 'Discovery',
    auth: 'u',
    meta: {
      title: 'Discovery',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/home-config/me',
    component: function component() {
      return import('@/views/home-config/me');
    },
    name: 'Me',
    auth: 'u',
    meta: {
      title: 'Me',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/home-config/service',
    component: function component() {
      return import('@/views/home-config/service');
    },
    name: 'Service',
    auth: 'u',
    meta: {
      title: 'Service',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/home-config/banner',
    component: function component() {
      return import('@/views/home-config/banner');
    },
    name: 'HomeConfigBanner',
    auth: ['u', 'ban'],
    meta: {
      title: 'Banner',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/home-config/mini-banner',
    component: function component() {
      return import('@/views/home-config/mini-banner');
    },
    name: 'HomeConfigMiniAppBanner',
    auth: 'u',
    meta: {
      title: 'Mini APP Banner',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/home-config/detail',
    component: function component() {
      return import('@/views/home-config/detail');
    },
    name: 'HomeConfigDetail',
    hidden: true,
    meta: {
      title: 'Detail',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/home-config/mini-detail',
    component: function component() {
      return import('@/views/home-config/mini-detail');
    },
    name: 'Mni Detail',
    hidden: true,
    meta: {
      title: 'Mini Detail',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/home-config/aicc-setting',
    component: function component() {
      return import('@/views/home-config/aicc-setting');
    },
    name: 'AICC login setting',
    auth: 'u',
    meta: {
      title: 'AICC login setting',
      icon: 'rorder',
      noCache: true
    }
  }]
},
//  碎屏险模块
{
  path: '/protection-package',
  component: Layout,
  redirect: '/protection-package/service-agreement',
  name: 'Protection Package',
  alwaysShow: true,
  meta: {
    title: 'Protection Package',
    icon: 'order'
  },
  isRoot: true,
  // auth: ['m', 'c', 'k', 'l', 'w'],
  // auth: ['bm', 'scs', 'pd', 'sr', 'nsr', 'ci', 'ocp', 'im', 'am', 'sl', 'pl', 'pr', 'rep', 'cca', 'dcl', 'pc_page'],
  auth: ['bm', 'scs', 'pd', 'sr', 'nsr', 'ci', 'im', 'am', 'rc', 'pr', 'rep', 'cca', 'dcl', 'pc_page', 'acb'],
  children: [{
    path: '/protection-package/service-agreement',
    component: function component() {
      return import('@/views/protection-package/service-agreement');
    },
    name: 'Service Agreement',
    auth: 'super',
    hidden: true,
    meta: {
      title: 'Service Agreement',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/protection-package/brand-model',
    component: function component() {
      return import('@/views/protection-package/brand-model');
    },
    name: 'Brand & Model',
    auth: ['bm'],
    meta: {
      title: 'Brand & Model',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/protection-package/sale-card-store',
    component: function component() {
      return import('@/views/protection-package/sale-card-store');
    },
    name: 'Sale Card Store',
    auth: ['scs'],
    meta: {
      title: 'Sale Card Store',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/protection-package/product-definition',
    component: function component() {
      return import('@/views/protection-package/product-definition');
    },
    name: 'Product Definition',
    auth: ['pd'],
    meta: {
      title: 'Product Definition',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/protection-package/produce-card',
    component: function component() {
      return import('@/views/protection-package/produce-card');
    },
    name: 'Produce Card',
    auth: ['pc_page'],
    meta: {
      title: 'Produce Card',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/protection-package/sales-record',
    component: function component() {
      return import('@/views/protection-package/sales-record');
    },
    name: 'Sales Record',
    auth: ['sr'],
    meta: {
      title: 'Sales Record',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/protection-package/refer-code',
    component: function component() {
      return import('@/views/protection-package/refer-code');
    },
    name: 'Referral Code List',
    auth: ['rc'],
    meta: {
      title: 'Referral Code List',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/protection-package/new-sales-record',
    component: function component() {
      return import('@/views/protection-package/new-sales-record');
    },
    name: 'New Protection Sales Record',
    auth: ['nsr'],
    meta: {
      title: 'New Protection Sales Record',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/protection-package/card-inventory',
    component: function component() {
      return import('@/views/protection-package/card-inventory');
    },
    name: 'Card Inventory',
    auth: ['ci'],
    meta: {
      title: 'Card Inventory',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/protection-package/online-card-price',
    component: function component() {
      return import('@/views/protection-package/online-card-price');
    },
    name: 'Online Card Price',
    auth: ['ocp'],
    meta: {
      title: 'Online Card Price',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/protection-package/inventory-manage',
    component: function component() {
      return import('@/views/protection-package/inventory-manage');
    },
    name: 'Inventory Management',
    auth: ['im'],
    meta: {
      title: 'Inventory Management',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/protection-package/activation-board',
    component: function component() {
      return import('@/views/protection-package/activation-board');
    },
    name: 'Activation Board',
    auth: ['acb'],
    meta: {
      title: 'Activation Board',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/protection-package/activation-manage',
    component: function component() {
      return import('@/views/protection-package/activation-manage');
    },
    name: 'Activation Management',
    auth: ['am'],
    meta: {
      title: 'Activation Management',
      icon: 'rorder',
      noCache: true
    }
  },
  // {
  //   path: '/protection-package/sales-list',
  //   component: () => import('@/views/protection-package/sales-list'),
  //   name: 'Sales List',
  //   auth: ['sl'],
  //   meta: { title: 'Sales List', icon: 'rorder', noCache: true }
  // },
  // {
  //   path: '/protection-package/price-list',
  //   component: () => import('@/views/protection-package/price-list'),
  //   name: 'Price List',
  //   auth: ['pl'],
  //   meta: { title: 'Price List', icon: 'rorder', noCache: true }
  // },
  {
    path: '/protection-package/performance-record',
    component: function component() {
      return import('@/views/protection-package/performance-record');
    },
    name: 'Performance Record',
    auth: ['pr'],
    meta: {
      title: 'Performance Record',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/protection-package/report',
    component: function component() {
      return import('@/views/protection-package/report');
    },
    name: 'Report',
    auth: ['rep'],
    meta: {
      title: 'Report',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/protection-package/cc-account',
    component: function component() {
      return import('@/views/protection-package/cc-account');
    },
    name: 'CC Account',
    auth: 'cca',
    meta: {
      title: 'CC Account',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/protection-package/destination-country-list',
    component: function component() {
      return import('@/views/protection-package/destination-country-list');
    },
    name: 'Destination Country List',
    auth: 'dcl',
    meta: {
      title: 'Destination Country List',
      icon: 'rorder',
      noCache: true
    }
  }
  // {
  //   path: '/protection-package/sss-screen-price',
  //   component: () => import('@/views/protection-package/sss-screen-price'),
  //   name: 'sss Screen Price',
  //   auth: 'm',
  //   meta: { title: 'sss Screen Price', icon: 'rorder', noCache: true }
  // },
  ]
},
//  换屏一口价
{
  path: '/fixed-price',
  component: Layout,
  redirect: '/fixed-price/banner',
  name: 'Fixed Price',
  alwaysShow: true,
  hidden: true,
  meta: {
    title: 'Fixed Price',
    icon: 'order'
  },
  isRoot: true,
  auth: ['super'],
  children: [{
    path: 'banner',
    component: function component() {
      return import('@/views/fixed-price/banner');
    },
    name: 'FixedPriceBanner',
    // hidden: true,
    auth: 'super',
    meta: {
      title: 'Banner',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'price',
    component: function component() {
      return import('@/views/fixed-price/price');
    },
    name: 'Price',
    // hidden: true,
    auth: 'super',
    meta: {
      title: 'Price',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'test-problem',
    component: function component() {
      return import('@/views/fixed-price/test-problem');
    },
    name: 'Test Problem',
    // hidden: true,
    auth: 'super',
    meta: {
      title: 'Test Problem',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'supported-store',
    component: function component() {
      return import('@/views/fixed-price/supported-store');
    },
    name: 'Supported Store',
    // hidden: true,
    auth: 'super',
    meta: {
      title: 'Supported Store',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'super-offer-order',
    component: function component() {
      return import('@/views/fixed-price/super-offer-order');
    },
    name: 'Super Offer Order',
    // hidden: true,
    auth: 'super',
    meta: {
      title: 'Super Offer Order',
      icon: 'rorder',
      noCache: true
    }
  }]
},
//  尼日利亚免费换后盖
{
  path: '/back-cover',
  component: Layout,
  redirect: '/back-cover/color',
  name: 'Battery Back Cover',
  alwaysShow: true,
  hidden: true,
  meta: {
    title: 'Battery Back Cover',
    icon: 'order'
  },
  isRoot: true,
  auth: ['super'],
  children: [{
    path: 'color',
    component: function component() {
      return import('@/views/back-cover/color');
    },
    name: 'Color',
    // hidden: true,
    auth: 'super',
    meta: {
      title: 'Color',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'supported-store',
    component: function component() {
      return import('@/views/back-cover/supported-store');
    },
    name: 'BackCoverSupportedStore',
    // hidden: true,
    auth: 'super',
    meta: {
      title: 'Supported Store',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'battery-back-order',
    component: function component() {
      return import('@/views/back-cover/battery-back-order');
    },
    name: 'Battery Back Order',
    // hidden: true,
    auth: 'super',
    meta: {
      title: 'Battery Back Order',
      icon: 'rorder',
      noCache: true
    }
  }]
},
//  商家上下架审批
{
  path: '/partner-service',
  component: Layout,
  redirect: '/partner-service/pending',
  name: 'Partner Service',
  alwaysShow: true,
  hidden: true,
  meta: {
    title: 'Partner Service',
    icon: 'order'
  },
  isRoot: true,
  auth: ['super'],
  children: [{
    path: 'pending',
    component: function component() {
      return import('@/views/partner-service/pending');
    },
    name: 'Pending Service',
    meta: {
      title: 'Pending Service',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'approved',
    component: function component() {
      return import('@/views/partner-service/approved');
    },
    name: 'Approved Service',
    meta: {
      title: 'Approved Service',
      icon: 'shopping',
      noCache: true
    }
  }, {
    path: 'detail',
    component: function component() {
      return import('@/views/partner-service/detail');
    },
    hidden: true,
    name: 'SparePartsDetail',
    meta: {
      title: 'Detail',
      noCache: true
    }
  }]
},
// 配件价格
{
  path: '/spare-price',
  component: Layout,
  redirect: '/spare-price/parts-price',
  name: 'Spare Parts Price',
  alwaysShow: true,
  meta: {
    title: 'Spare Parts Price',
    icon: 'order'
  },
  isRoot: true,
  auth: ['eup'],
  children: [{
    path: '/spare-price/parts-price',
    component: function component() {
      return import('@/views/spare-price/parts-price');
    },
    name: 'SparePartsPrice',
    auth: 'super',
    meta: {
      title: 'Spare Parts Price',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/spare-price/market-name',
    component: function component() {
      return import('@/views/spare-price/market-name');
    },
    name: 'Model & Market Name',
    auth: 'super',
    meta: {
      title: 'Model & Market Name',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/spare-price/labor-price',
    component: function component() {
      return import('@/views/spare-price/labor-price');
    },
    name: 'EU Labor Cost Price',
    auth: 'eup',
    meta: {
      title: 'EU Labor Cost Price',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/spare-price/type-config',
    component: function component() {
      return import('@/views/spare-price/type-config');
    },
    name: 'Consume B Type Config',
    auth: 'super',
    meta: {
      title: 'Consume B Type Config',
      icon: 'rorder',
      noCache: true
    }
  }]
},
//  防串货2.0
{
  path: '/lock-machine',
  component: Layout,
  redirect: '/lock-machine/appealing-audit',
  name: 'Locking machine Audit',
  alwaysShow: true,
  meta: {
    title: 'Locking machine Audit',
    icon: 'order'
  },
  isRoot: true,
  auth: ['l-1', 'l-5', 'l-6', 'aw', 'bdaa'],
  children: [{
    path: '/appealing-audit',
    component: function component() {
      return import('@/views/lock-machine/appealing-audit');
    },
    name: 'Appealing Audit',
    auth: 'l-1',
    meta: {
      title: 'Appealing Audit',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/appealing-progress',
    component: function component() {
      return import('@/views/lock-machine/appealing-progress');
    },
    name: 'Appealing Progress',
    auth: 'l-6',
    meta: {
      title: 'Appealing Progress',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/batch-audit',
    component: function component() {
      return import('@/views/lock-machine/batch-audit');
    },
    name: 'Batch & Sumbit Audit',
    auth: 'l-5',
    meta: {
      title: 'Batch & Sumbit Audit',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/appealing-white',
    component: function component() {
      return import('@/views/lock-machine/appealing-white');
    },
    name: 'Appealing White List',
    auth: 'aw',
    meta: {
      title: 'Appealing White List',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/bd-account',
    component: function component() {
      return import('@/views/lock-machine/bd-account');
    },
    name: 'BD Appealing Account List',
    auth: 'bdaa',
    meta: {
      title: 'BD Appealing Account List',
      icon: 'rorder',
      noCache: true
    }
  }]
},
//  优惠券管理
{
  path: '/coupon-management',
  component: Layout,
  redirect: '/coupon-management/coupon-list',
  name: 'Coupon Management',
  alwaysShow: true,
  meta: {
    title: 'Coupon Management',
    icon: 'order'
  },
  auth: ['super'],
  isRoot: true,
  children: [{
    path: 'coupon-list',
    component: function component() {
      return import('@/views/coupon-management/coupon-list');
    },
    name: 'Coupon List',
    auth: 'super',
    meta: {
      title: 'Coupon List',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: 'detail',
    component: function component() {
      return import('@/views/coupon-management/detail');
    },
    hidden: true,
    name: 'CouponManagementDetail',
    meta: {
      title: 'Detail',
      noCache: true
    }
  }]
},
//  faq
{
  path: '/faq',
  component: Layout,
  redirect: '/faq/index',
  name: 'FAQ',
  alwaysShow: true,
  meta: {
    title: 'FAQ',
    icon: 'order'
  },
  isRoot: true,
  auth: ['faq'],
  children: [{
    path: '/faq/index',
    component: function component() {
      return import('@/views/faq/index');
    },
    name: 'FAQ Setting',
    auth: 'faq',
    meta: {
      title: 'FAQ Setting',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 排队叫号管理
{
  path: '/queue-manage',
  component: Layout,
  redirect: '/queue-manage/available-user',
  name: 'Queue Management',
  alwaysShow: true,
  meta: {
    title: 'Queue Management',
    icon: 'order'
  },
  isRoot: true,
  auth: ['qum'],
  children: [{
    path: '/queue-manage/available-user',
    component: function component() {
      return import('@/views/queue-manage/available-user');
    },
    name: 'Available User List',
    auth: 'qum',
    meta: {
      title: 'Available User List',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 用户协议 && 隐私政策多配置
{
  path: '/terms-policy',
  component: Layout,
  redirect: '/terms-policy/terms-user',
  name: 'Terms of User & Privacy Policy',
  alwaysShow: true,
  meta: {
    title: 'Terms of User & Privacy Policy',
    icon: 'order'
  },
  isRoot: true,
  auth: ['super'],
  children: [{
    path: '/terms-policy/terms-user',
    component: function component() {
      return import('@/views/terms-policy/terms-user');
    },
    name: 'Terms of User',
    auth: 'super',
    meta: {
      title: 'Terms of User',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/terms-policy/privacy-policy',
    component: function component() {
      return import('@/views/terms-policy/privacy-policy');
    },
    name: 'Privacy Policy',
    auth: 'super',
    meta: {
      title: 'Privacy Policy',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/terms-policy/cookie-policy',
    component: function component() {
      return import('@/views/terms-policy/cookie-policy');
    },
    name: 'Cookie Policy',
    auth: 'super',
    meta: {
      title: 'Cookie Policy',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 反馈管理
{
  path: '/feedback',
  component: Layout,
  redirect: '/feedback/index',
  name: 'Feedback Manage',
  alwaysShow: true,
  meta: {
    title: 'Feedback Manage',
    icon: 'order'
  },
  isRoot: true,
  auth: ['fb'],
  children: [{
    path: '/feedback/index',
    component: function component() {
      return import('@/views/feedback/index');
    },
    name: 'Feedback List',
    auth: 'fb',
    meta: {
      title: 'Feedback List',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 问卷调查
{
  path: '/satisfaction-survey',
  component: Layout,
  redirect: '/satisfaction-survey/index',
  name: 'Satisfaction Survey',
  alwaysShow: true,
  meta: {
    title: 'Satisfaction Survey',
    icon: 'order'
  },
  isRoot: true,
  // 子菜单粒度权限：任一子项有权限即展示父菜单（hs 同时控制 H5 Survey List）
  auth: ['hs', 'ss_app', 'ss_app_new', 'ss_app_new2', 'ss_web', 'ss_web_new', 'ss_web_new2'],
  children: [{
    path: '/satisfaction-survey/index',
    component: function component() {
      return import('@/views/satisfaction-survey/index');
    },
    name: 'App Survey List',
    auth: 'ss_app',
    meta: {
      title: 'App Survey List',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/satisfaction-survey/detail',
    component: function component() {
      return import('@/views/satisfaction-survey/detail');
    },
    hidden: true,
    name: 'Survey Detail',
    meta: {
      title: 'Survey Detail',
      noCache: true
    }
  }, {
    path: '/satisfaction-survey/app-new',
    component: function component() {
      return import('@/views/satisfaction-survey/app-new');
    },
    name: 'App Survey List (New)',
    auth: 'ss_app_new',
    meta: {
      title: 'App Survey List (New)',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/satisfaction-survey/app-new-2',
    component: function component() {
      return import('@/views/satisfaction-survey/app-new-2');
    },
    name: 'App Survey List 2 (New)',
    auth: 'ss_app_new2',
    meta: {
      title: 'App Survey List 2 (New)',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/satisfaction-survey/app-detail-new',
    component: function component() {
      return import('@/views/satisfaction-survey/app-detail-new');
    },
    hidden: true,
    name: 'AppSurveyDetailNew',
    meta: {
      title: 'Survey Detail',
      noCache: true
    }
  }, {
    path: '/satisfaction-survey/web',
    component: function component() {
      return import('@/views/satisfaction-survey/web');
    },
    name: 'Web Survey List',
    auth: 'ss_web',
    meta: {
      title: 'Web Survey List',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/satisfaction-survey/web-detail',
    component: function component() {
      return import('@/views/satisfaction-survey/web-detail');
    },
    hidden: true,
    name: 'WebSurveyDetail',
    meta: {
      title: 'Survey Detail',
      noCache: true
    }
  }, {
    path: '/satisfaction-survey/web-new',
    component: function component() {
      return import('@/views/satisfaction-survey/web-new');
    },
    name: 'Web Survey List (New)',
    auth: 'ss_web_new',
    meta: {
      title: 'Web Survey List (New)',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/satisfaction-survey/web-new-2',
    component: function component() {
      return import('@/views/satisfaction-survey/web-new-2');
    },
    name: 'Web Survey List 2 (New)',
    auth: 'ss_web_new2',
    meta: {
      title: 'Web Survey List 2 (New)',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/satisfaction-survey/web-detail-new',
    component: function component() {
      return import('@/views/satisfaction-survey/web-detail-new');
    },
    hidden: true,
    name: 'WebSurveyDetailNew',
    meta: {
      title: 'Survey Detail',
      noCache: true
    }
  }, {
    path: '/satisfaction-survey/h5',
    component: function component() {
      return import('@/views/satisfaction-survey/h5');
    },
    auth: 'hs',
    name: 'H5 Survey List',
    meta: {
      title: 'H5 Survey List',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/satisfaction-survey/h5-detail',
    component: function component() {
      return import('@/views/satisfaction-survey/h5-detail');
    },
    hidden: true,
    name: 'H5SurveyDetail',
    meta: {
      title: 'Survey Detail',
      noCache: true
    }
  }]
},
// 中高端机型
{
  path: '/high-model',
  component: Layout,
  redirect: '/high-model/index',
  name: 'Medium to high-end models',
  alwaysShow: true,
  meta: {
    title: 'Medium to high-end models',
    icon: 'order'
  },
  isRoot: true,
  auth: ['super'],
  children: [{
    path: '/high-model/index',
    component: function component() {
      return import('@/views/high-model/index');
    },
    name: 'Medium to high-end models List',
    auth: 'super',
    meta: {
      title: 'Medium to high-end models List',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/high-model/user-coin',
    component: function component() {
      return import('@/views/high-model/user-coin');
    },
    name: 'Medium to high-end User Points',
    auth: 'super',
    meta: {
      title: 'Medium to high-end User Points',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/high-model/task-setting',
    component: function component() {
      return import('@/views/high-model/task-setting');
    },
    name: 'Medium to high-end Points Task',
    auth: 'super',
    meta: {
      title: 'Medium to high-end Points Task',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/high-model/rules',
    component: function component() {
      return import('@/views/high-model/rules');
    },
    name: 'Medium to high-end Points Rules',
    auth: 'super',
    meta: {
      title: 'Medium to high-end Points Rules',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/high-model/activity',
    component: function component() {
      return import('@/views/high-model/activity');
    },
    name: 'Medium to high-end Activity',
    auth: 'super',
    meta: {
      title: 'Medium to high-end Activity',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/high-model/draw-result',
    component: function component() {
      return import('@/views/high-model/draw-result');
    },
    name: 'Medium to high-end Draw Result',
    auth: 'super',
    meta: {
      title: 'Medium to high-end Draw Result',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/high-model/ai-assistant',
    component: function component() {
      return import('@/views/high-model/ai-assistant');
    },
    name: 'AI Assistant',
    auth: 'super',
    meta: {
      title: 'AI Assistant',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/high-model/benefit',
    component: function component() {
      return import('@/views/high-model/benefit');
    },
    name: 'My Benefits',
    auth: 'super',
    meta: {
      title: 'My Benefits',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/high-model/point-mall',
    component: function component() {
      return import('@/views/high-model/point-mall');
    },
    name: 'Point Mall',
    auth: 'super',
    meta: {
      title: 'Point Mall',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/high-model/gift',
    component: function component() {
      return import('@/views/high-model/gift');
    },
    name: 'Gift',
    auth: 'super',
    meta: {
      title: 'Gift',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/high-model/gift-claim',
    component: function component() {
      return import('@/views/high-model/gift-claim');
    },
    name: 'Gift Claim',
    auth: 'super',
    meta: {
      title: 'Gift Claim',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 融合搜索配置
{
  path: '/search-config',
  component: Layout,
  redirect: '/search-config/trending-activity',
  name: 'Search Config',
  alwaysShow: true,
  meta: {
    title: 'Search Config',
    icon: 'order'
  },
  isRoot: true,
  auth: ['super'],
  children: [
  // {
  //   path: '/search-config/hot-search',
  //   component: () => import('@/views/search-config/hot-search'),
  //   name: 'Hot Search',
  //   meta: { title: 'Hot Search', icon: 'user', noCache: true }
  // },
  {
    path: '/search-config/trending-activity',
    component: function component() {
      return import('@/views/search-config/trending-activity');
    },
    name: 'Trending Activities',
    meta: {
      title: 'Trending Activities',
      icon: 'user',
      noCache: true
    }
  }]
},
// 官网中高端机型权益
{
  path: '/exclusive-benefit',
  component: Layout,
  redirect: '/exclusive-benefit/benefit',
  name: 'Exclusive Benefits',
  alwaysShow: true,
  meta: {
    title: 'Exclusive Benefits',
    icon: 'order'
  },
  isRoot: true,
  auth: ['eb'],
  children: [{
    path: '/exclusive-benefit/benefit',
    component: function component() {
      return import('@/views/exclusive-benefit/benefit');
    },
    name: 'Benefits',
    auth: 'eb',
    meta: {
      title: 'Benefits',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/exclusive-benefit/banner',
    component: function component() {
      return import('@/views/exclusive-benefit/banner');
    },
    name: 'ExclusiveBenefitBanner',
    auth: 'eb',
    meta: {
      title: 'Banner',
      icon: 'edit',
      noCache: true
    }
  }, {
    path: '/exclusive-benefit/remark',
    component: function component() {
      return import('@/views/exclusive-benefit/remark');
    },
    name: 'Remark',
    auth: 'eb',
    meta: {
      title: 'Remark',
      icon: 'edit',
      noCache: true
    }
  }]
},
// 官网新增carlcare protection页面配置
{
  path: '/carlcare-protection',
  component: Layout,
  redirect: '/carlcare-protection/banner',
  name: 'Carlcare Protection',
  alwaysShow: true,
  meta: {
    title: 'Carlcare Protection',
    icon: 'order'
  },
  isRoot: true,
  auth: ['cp'],
  children: [{
    path: '/carlcare-protection/banner',
    component: function component() {
      return import('@/views/carlcare-protection/banner');
    },
    name: 'CarlcareProtectionBanner',
    auth: 'cp',
    meta: {
      title: 'Banner',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/carlcare-protection/terms',
    component: function component() {
      return import('@/views/carlcare-protection/terms');
    },
    name: 'Terms',
    auth: 'cp',
    meta: {
      title: 'Terms',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/carlcare-protection/faq',
    component: function component() {
      return import('@/views/carlcare-protection/faq');
    },
    name: 'CarlcareProtectionFAQ',
    auth: 'cp',
    meta: {
      title: 'FAQ',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/carlcare-protection/terms-user',
    component: function component() {
      return import('@/views/carlcare-protection/terms-user');
    },
    name: 'Terms of Purchase or Active Protection',
    auth: 'cp',
    meta: {
      title: 'Terms of Purchase or Active Protection',
      icon: 'user',
      noCache: true
    }
  }]
},
// 用户成长体系
{
  path: '/member-manage',
  component: Layout,
  redirect: '/member-manage/index',
  name: 'Member Management',
  alwaysShow: true,
  meta: {
    title: 'Member Management',
    icon: 'order'
  },
  isRoot: true,
  auth: ['super'],
  children: [{
    path: '/member-manage/index',
    component: function component() {
      return import('@/views/member-manage/index');
    },
    name: 'Member List',
    auth: 'super',
    meta: {
      title: 'Member List',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/member-manage/level',
    component: function component() {
      return import('@/views/member-manage/level');
    },
    name: 'Level Setting',
    auth: 'super',
    meta: {
      title: 'Level Setting',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/member-manage/task',
    component: function component() {
      return import('@/views/member-manage/task');
    },
    name: 'Task Setting',
    auth: 'super',
    meta: {
      title: 'Task Setting',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/member-manage/draw-setting',
    component: function component() {
      return import('@/views/member-manage/draw-setting');
    },
    name: 'Member Draw Setting',
    auth: 'super',
    meta: {
      title: 'Member Draw Setting',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/member-manage/draw-result',
    component: function component() {
      return import('@/views/member-manage/draw-result');
    },
    name: 'Member Draw Result',
    auth: 'super',
    meta: {
      title: 'Member Draw Result',
      icon: 'rorder',
      noCache: true
    }
  }]
}, {
  path: '/imei-inquiry',
  component: Layout,
  redirect: '/imei-inquiry/index',
  name: 'IMEI Inquiry Statistics',
  alwaysShow: true,
  meta: {
    title: 'IMEI Inquiry Statistics',
    icon: 'order'
  },
  isRoot: true,
  auth: ['super'],
  hidden: true,
  children: [{
    path: '/imei-inquiry/index',
    component: function component() {
      return import('@/views/imei-inquiry/index');
    },
    name: 'Inquiry List',
    auth: 'super',
    meta: {
      title: 'Inquiry List',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// H5印尼保险
{
  path: '/protection-setting',
  component: Layout,
  redirect: '/protection-setting/indonesia',
  name: 'protection setting',
  alwaysShow: true,
  meta: {
    title: 'protection setting',
    icon: 'order'
  },
  isRoot: true,
  auth: ['super'],
  hidden: true,
  children: [{
    path: '/protection-setting/indonesia',
    component: function component() {
      return import('@/views/protection-setting/indonesia');
    },
    name: 'ProtectionSettingIndonesia',
    auth: 'super',
    meta: {
      title: 'Indonesia',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 批量发邮件
{
  path: '/bulk-email',
  component: Layout,
  redirect: '/bulk-email/index',
  name: 'Bulk E-Mail',
  alwaysShow: true,
  meta: {
    title: 'Bulk E-Mail',
    icon: 'order'
  },
  isRoot: true,
  auth: ['super'],
  hidden: true,
  children: [{
    path: '/bulk-email/index',
    component: function component() {
      return import('@/views/bulk-email/index');
    },
    name: 'Bulk E-Mail List',
    auth: 'super',
    meta: {
      title: 'Bulk E-Mail List',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 官网/app接入大搜，关于service的后台配置
{
  path: '/search-setting',
  component: Layout,
  redirect: '/search-setting/web-setting',
  name: 'Search Setting',
  alwaysShow: true,
  meta: {
    title: 'Search Setting',
    icon: 'order'
  },
  isRoot: true,
  auth: ['super'],
  children: [{
    path: '/search-setting/web-setting',
    component: function component() {
      return import('@/views/search-setting/web-setting');
    },
    name: 'Office Web Search Setting',
    auth: 'super',
    meta: {
      title: 'Office Web Search Setting',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/search-setting/app-setting',
    component: function component() {
      return import('@/views/search-setting/app-setting');
    },
    name: 'APP Search Setting',
    auth: 'super',
    meta: {
      title: 'APP Search Setting',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 品牌机型配置图片
{
  path: '/model-image',
  component: Layout,
  redirect: '/model-image/image-setting',
  name: 'Model Image',
  alwaysShow: true,
  meta: {
    title: 'Model Image',
    icon: 'order'
  },
  isRoot: true,
  auth: ['super'],
  children: [{
    path: '/model-image/image-setting',
    component: function component() {
      return import('@/views/model-image/image-setting');
    },
    name: 'Model Image Setting',
    auth: 'super',
    meta: {
      title: 'Model Image Setting',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// AI故障后台配置
{
  path: '/ai-recognition',
  component: Layout,
  redirect: '/ai-recognition/history',
  name: 'AI Recognition',
  alwaysShow: true,
  meta: {
    title: 'AI Recognition',
    icon: 'order'
  },
  isRoot: true,
  auth: ['super'],
  children: [{
    path: '/ai-recognition/history',
    component: function component() {
      return import('@/views/ai-recognition/history');
    },
    name: 'AI Recognition History',
    auth: 'super',
    meta: {
      title: 'AI Recognition History',
      icon: 'rorder',
      noCache: true
    }
  }, {
    path: '/ai-recognition/ai-fault',
    component: function component() {
      return import('@/views/ai-recognition/ai-fault');
    },
    name: 'Fault Type & Description',
    auth: 'super',
    meta: {
      title: 'Fault Type & Description',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 配置短链
{
  path: '/short-key',
  component: Layout,
  redirect: '/short-key/index',
  name: 'Short Key',
  alwaysShow: true,
  meta: {
    title: 'Short Key',
    icon: 'order'
  },
  isRoot: true,
  auth: ['super'],
  children: [{
    path: '/short-key/index',
    component: function component() {
      return import('@/views/short-key/index');
    },
    name: 'ShortKeyIndex',
    auth: 'super',
    meta: {
      title: 'Short Key',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 手机故障自检后台配置
{
  path: '/solution',
  component: Layout,
  redirect: '/solution/exception-solution',
  name: 'Solution Setting',
  alwaysShow: true,
  meta: {
    title: 'Solution Setting',
    icon: 'order'
  },
  isRoot: true,
  auth: ['es'],
  children: [{
    path: '/solution/exception-solution',
    component: function component() {
      return import('@/views/solution/exception-solution');
    },
    name: 'Exception Solution',
    auth: 'es',
    meta: {
      title: 'Exception Solution',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 手机故障自检后台配置
{
  path: '/detection-result',
  component: Layout,
  redirect: '/detection-result/detection-detail',
  name: 'Detection Result',
  alwaysShow: true,
  meta: {
    title: 'Detection Result',
    icon: 'order'
  },
  isRoot: true,
  auth: ['dd'],
  children: [{
    path: '/detection-result/detection-detail',
    component: function component() {
      return import('@/views/detection-result/detection-detail');
    },
    name: 'Detection Detail',
    auth: 'dd',
    meta: {
      title: 'Detection Detail',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 手机故障自检后台配置 --- 检测项配置
{
  path: '/detection-setting',
  component: Layout,
  redirect: '/detection-setting/detection-list',
  name: 'Detection Setting',
  alwaysShow: true,
  meta: {
    title: 'Detection Setting',
    icon: 'order'
  },
  isRoot: true,
  auth: ['del'],
  children: [{
    path: '/detection-setting/detection-list',
    component: function component() {
      return import('@/views/detection-setting/detection-list');
    },
    name: 'Detection List',
    auth: 'del',
    meta: {
      title: 'Detection List',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 手机故障自检后台配置 --- 国家配置
{
  path: '/detection-country',
  component: Layout,
  redirect: '/detection-country/detection-country-list',
  name: 'Detection Country',
  alwaysShow: true,
  meta: {
    title: 'Detection Country',
    icon: 'order'
  },
  isRoot: true,
  auth: ['dec'],
  children: [{
    path: '/detection-country/detection-country-list',
    component: function component() {
      return import('@/views/detection-country/detection-country-list');
    },
    name: 'Detection Country List',
    auth: 'dec',
    meta: {
      title: 'Detection Country List',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 新品类维保注册--后台审批
{
  path: '/sn-invoice',
  component: Layout,
  redirect: '/sn-invoice/audit',
  name: 'SN Invoice Audit',
  alwaysShow: true,
  meta: {
    title: 'SN Invoice Audit',
    icon: 'order'
  },
  isRoot: true,
  auth: ['super'],
  hidden: true,
  children: [{
    path: '/sn-invoice/audit',
    component: function component() {
      return import('@/views/sn-invoice/audit');
    },
    name: 'Audit List',
    auth: 'super',
    meta: {
      title: 'Audit List',
      icon: 'rorder',
      noCache: true
    }
  }]
},
// 新品类维保注册--后台审批
{
  path: '/problem-check',
  component: Layout,
  redirect: '/problem-check/check-help',
  name: 'Problem Check and Help',
  alwaysShow: true,
  meta: {
    title: 'Problem Check and Help',
    icon: 'order'
  },
  isRoot: true,
  auth: ['pch'],
  children: [{
    path: '/problem-check/check-help',
    component: function component() {
      return import('@/views/problem-check/check-help');
    },
    name: 'Problem Check and Help List',
    auth: 'pch',
    meta: {
      title: 'Problem Check and Help List',
      icon: 'rorder',
      noCache: true
    }
  }]
}, {
  path: '/error-log',
  component: Layout,
  hidden: true,
  children: [{
    path: 'log',
    component: function component() {
      return import('@/views/error-log/index');
    },
    name: 'ErrorLog',
    meta: {
      title: 'errorLog',
      icon: 'bug'
    }
  }]
},
// 404 page must be placed at the end !!!
{
  path: '*',
  redirect: '/404',
  hidden: true
}];
var createRouter = function createRouter() {
  return new Router({
    // mode: 'history', // require service support
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;